import { get } from 'lodash';
import React, { memo } from 'react';
import type { CellProps } from 'react-table';

import type { TableColumnInstance, Tournament } from '../../../types/MTT';

import TableCellBase from './TableCellBase';

const TableCell: React.FC<CellProps<Tournament>> = memo((props) => {
  const { renderValueAccessor = '' } = props.column as TableColumnInstance;
  const displayValue = get(props.row.original, renderValueAccessor);
  return <TableCellBase {...props} displayValue={displayValue} />;
});

export default TableCell;
